import type { SearchResultJob } from '@seek/chalice-types';
import MetaLinkRenderer from './JobListItem/MetaLinkRenderer/MetaLinkRenderer';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

type PartialSearchResultJob = Pick<SearchResultJob, 'companyName'> & {
  advertiser: Pick<SearchResultJob['advertiser'], 'id' | 'description'>;
  isPrivateAdvertiser?: boolean;
};

export function CompanyLink({ job }: { job: PartialSearchResultJob }) {
  const { t } = useTranslations(translations);

  const advertiserDescription = job.advertiser.description || '';

  const metaLinkItem = {
    title: t('Jobs at {companyName}', {
      companyName: job.companyName ?? advertiserDescription,
    }),
    name: advertiserDescription,
    params: job.companyName
      ? { keywords: job.companyName }
      : { advertiserid: job.advertiser.id },
  };

  return job.isPrivateAdvertiser ? (
    <span>{advertiserDescription}</span>
  ) : (
    <MetaLinkRenderer item={metaLinkItem} type="company" />
  );
}
